import React from 'react';
import { getHeaderTemplate } from '../utils/headerTemplates';
import Header4ExclusiveSettings from './Header4ExclusiveSettings';
import Header6ExclusiveSettings from './Header6ExclusiveSettings';
import Header7ExclusiveSettings from './Header7ExclusiveSettings';
import HeaderInlineNavSettings from './HeaderInlineNavSettings';

interface HeaderExclusiveSettingsProps {
  config: any;
  onHeaderSettingChange: (setting: any, value: any) => void;
  onOpenIconModal: (cardType: 'card1' | 'card2', category: 'phone' | 'cart') => void;
  configId?: string;
}

/**
 * Şablona özel header ayarları — yalnızca seçili şablonun capability'si açık olan bloklar gelir.
 * Ortak ayarlar HeaderCommonSettings'te kalır; her yeni şablon kendi dosyasına eklenir.
 */
const HeaderExclusiveSettings: React.FC<HeaderExclusiveSettingsProps> = ({
  config,
  onHeaderSettingChange,
  onOpenIconModal,
  configId,
}) => {
  const caps = getHeaderTemplate(config.headerSettings?.headerType).capabilities;

  return (
    <>
      {caps.header4Cards && (
        <Header4ExclusiveSettings
          config={config}
          onHeaderSettingChange={onHeaderSettingChange}
          onOpenIconModal={onOpenIconModal}
        />
      )}

      {caps.inlineNav && (
        <HeaderInlineNavSettings
          config={config}
          onHeaderSettingChange={onHeaderSettingChange}
          configId={configId}
        />
      )}

      {caps.orderButton && (
        <Header6ExclusiveSettings
          config={config}
          onHeaderSettingChange={onHeaderSettingChange}
        />
      )}

      {(caps.overlay || caps.ctaButton) && (
        <Header7ExclusiveSettings
          config={config}
          onHeaderSettingChange={onHeaderSettingChange}
        />
      )}
    </>
  );
};

export default HeaderExclusiveSettings;
